/* ============================================================
   AUREATE v3 — comportements de la refonte (2026-08-14)
   Aucun contenu n'est masqué tant que ce script n'a pas tourné.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------------------------------------
     2. Décalage du collant : la colonne d'achat se cale sous
        l'en-tête réel, pas sous une valeur devinée.
     -------------------------------------------------------- */
  function calerLeCollant() {
    var h = document.querySelector('.section-header, #shopify-section-header, header.header');
    var ann = document.querySelector('.announcement-bar, [class*="announcement"]');
    var top = 24;
    if (h) top += Math.round(h.getBoundingClientRect().height);
    if (ann && getComputedStyle(ann).position === 'fixed') {
      top += Math.round(ann.getBoundingClientRect().height);
    }
    document.documentElement.style.setProperty('--au-sticky-top', top + 'px');
  }

  /* --------------------------------------------------------
     3. Champ de gravure : compteur + rappel de la casse rendue.
        On n'invente aucune promesse — on montre ce qui sera gravé.
     -------------------------------------------------------- */
  /* Le champ de gravure est injecté par l'app YMQ APRÈS le chargement :
     un sélecteur joué une seule fois au DOMContentLoaded ne trouve rien.
     Mesuré : `input.ymq-input-text.ymq-option-text`, maxlength=10, dans
     `.ymq-option-text-input-wrapper`. La zone de note du panier
     (`.ymq-cart-app-note-input`) porte les mêmes classes de famille : exclue. */
  var SEL_GRAVURE = 'input.ymq-option-text, input.ymq-input-text[maxlength],' +
                    ' input[type="text"][name*="properties"], textarea[name*="properties"]';

  function habillerLaGravure() {
    var champs = document.querySelectorAll(SEL_GRAVURE);
    Array.prototype.forEach.call(champs, function (input) {
      if (input.classList.contains('ymq-cart-app-note-input')) return;
      var hote = input.closest('.ymq-option-text-input-wrapper, .ymq-option, .product-form__input')
                 || input.parentNode;
      if (!hote || hote.querySelector('.au-engrave-hint')) return;
      hote.setAttribute('data-au-engrave', '');

      var aide = document.createElement('div');
      aide.className = 'au-engrave-hint';
      var gauche = document.createElement('span');
      gauche.innerHTML = 'Engraved exactly as typed — <b>check your spelling</b>';
      aide.appendChild(gauche);

      /* Pas de compteur de caractères ici : l'app YMQ en peint déjà un
         dans le champ (« 0/10 »). Mesuré — un second exemplaire affichait
         deux fois le même chiffre à 4 px d'écart. Ce que la cliente n'a
         nulle part, c'est l'avertissement d'orthographe : c'est le seul
         ajout, et il suffit. */
      hote.appendChild(aide);
    });
  }

  /* --------------------------------------------------------
     4. Pastilles de métal sur les cartes produit.
        Lues depuis les données de la carte, jamais devinées :
        si le nom d'option n'est pas là, aucune pastille n'est peinte.
     -------------------------------------------------------- */
  var METAUX = [
    { motif: /rose\s*gold/i, classe: 'au-swatch--rose' },
    { motif: /(18k|gold|dor)/i, classe: 'au-swatch--gold' },
    { motif: /(silver|steel|argent)/i, classe: 'au-swatch--silver' }
  ];

  function pastillesCartes() {
    var cartes = document.querySelectorAll('.card-wrapper, .card__content');
    Array.prototype.forEach.call(cartes, function (carte) {
      if (carte.querySelector('.au-swatches')) return;
      var src = carte.getAttribute('data-variants') || '';
      if (!src) {
        var opts = carte.querySelectorAll('[data-option-value], .swatch, .card__swatch');
        if (opts.length) {
          src = Array.prototype.map.call(opts, function (o) {
            return o.getAttribute('data-option-value') || o.title || o.textContent || '';
          }).join(' ');
        }
      }
      if (!src.trim()) return;                       // pas de donnée = pas de pastille
      var vues = {};
      METAUX.forEach(function (m) {
        if (m.motif.test(src)) vues[m.classe] = true;
      });
      var classes = Object.keys(vues);
      if (classes.length < 2) return;                // une seule finition = rien à montrer
      var box = document.createElement('div');
      box.className = 'au-swatches';
      box.setAttribute('aria-hidden', 'true');
      classes.forEach(function (c) {
        var d = document.createElement('span');
        d.className = 'au-swatch ' + c;
        box.appendChild(d);
      });
      var info = carte.querySelector('.card__information, .card-information') || carte;
      info.insertBefore(box, info.firstChild);
    });
  }


  /* --------------------------------------------------------
     Échelle de finitions : nos cartes ACTIONNENT les radios
     natifs du thème, elles ne dupliquent aucun état. Le thème
     reste seul maître de la variante sélectionnée.
     -------------------------------------------------------- */
  function echelleFinitions() {
    var bloc = document.querySelector('[data-au-finitions]');
    if (!bloc) return;
    var nomOption = bloc.getAttribute('data-au-option');
    var radios = document.querySelectorAll('input[type="radio"][name="' + nomOption + '"]');
    if (!radios.length) return;

    function synchroniser() {
      var actif = null;
      Array.prototype.forEach.call(radios, function (r) { if (r.checked) actif = r.value; });
      Array.prototype.forEach.call(bloc.querySelectorAll('.au-fin__card'), function (c) {
        c.setAttribute('aria-pressed', c.getAttribute('data-au-valeur') === actif ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(bloc.querySelectorAll('.au-fin__card'), function (carte) {
      if (carte.getAttribute('data-au-cable')) return;
      carte.setAttribute('data-au-cable', '1');
      carte.addEventListener('click', function () {
        if (carte.getAttribute('aria-disabled') === 'true') return;
        var val = carte.getAttribute('data-au-valeur');
        Array.prototype.forEach.call(radios, function (r) {
          if (r.value === val) {
            var lab = document.querySelector('label[for="' + r.id + '"]');
            if (lab) { lab.click(); } else { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
          }
        });
        setTimeout(synchroniser, 60);
      });
    });

    Array.prototype.forEach.call(radios, function (r) {
      r.addEventListener('change', synchroniser);
    });
    synchroniser();
  }

  function demarrer() {
    calerLeCollant();
    habillerLaGravure();
    echelleFinitions();
    pastillesCartes();
  }

  /* Guetteur borné : l'app d'options et les grilles en chargement différé
     arrivent après nous. On repasse quand le DOM bouge, 20 s au plus —
     puis on s'arrête, pour ne pas laisser un observateur tourner à vie. */
  function guetter() {
    if (!('MutationObserver' in window)) return;
    var fini = false;
    var mo = new MutationObserver(function () {
      if (fini) return;
      habillerLaGravure();
    echelleFinitions();
      pastillesCartes();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { fini = true; mo.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { demarrer(); guetter(); });
  } else {
    demarrer();
    guetter();
  }

  window.addEventListener('resize', calerLeCollant, { passive: true });
  // le thème rafraîchit des sections en Ajax : on repasse derrière
  document.addEventListener('shopify:section:load', demarrer);
})();
